/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import Listable from '@zcode/nr/es/shared/bizos/listable'
import type {
  CardBackResponse,
  CardBackReview,
  CardBackReviewsSummary,
  CardBackSupplementalDescription,
  Listable as ListableType,
  RawListable,
} from '@zcode/state-type'

interface Props {
  spotlightArray:
    | {
        listables: RawListable[]
        matching: number
      }
    | undefined
  spotlightCardBacks: CardBackResponse
  seenUids: Set<ListableType['uId']>
}

export const appendSpotlightData = ({ spotlightArray, spotlightCardBacks, seenUids }: Props) => {
  if (spotlightArray && 'listables' in spotlightArray) {
    return spotlightArray.listables.map((listable: RawListable) => {
      const groupIdString = String(listable.group_id)
      let review: CardBackReview | undefined
      let supple_description: CardBackSupplementalDescription | undefined
      let reviews_summary: CardBackReviewsSummary | undefined
      if (spotlightCardBacks[groupIdString]) {
        review = spotlightCardBacks[groupIdString].review
        supple_description = spotlightCardBacks[groupIdString].supple_description
        reviews_summary = spotlightCardBacks[groupIdString].reviews_summary
      }
      const augmentedListable = Listable.fromJS({
        supple_description,
        is_spotlight: true,
        review,
        reviews_summary,
        ...listable,
      })

      seenUids.add(augmentedListable.uId)

      return augmentedListable
    })
  }
}
